<script>
    import { onMount } from 'svelte';
    import { fetchCertifcateByHash } from '/public/services/User.js';
    import { slide } from 'svelte/transition';

    export let currentRoute;

    let hash = currentRoute.namedParams.hash;
    let loading = true;
    let cert = null;
    let error = false;

    function loadCert() {
        error = false;

        fetchCertifcateByHash(hash).then(res => {
            if (res.success) {
                cert = res.data.cert;
            } else {
                error = true;
            }

            loading = false;
        });
    }

    onMount(() => {
        loadCert();
    });
</script>
{#if loading === true}

    <div class='text-center'>
        <h4>
            <span class='ajax-ball-loader'></span> Validating your Certificate....
        </h4>
    </div>

{:else}

    {#if error === false}

        <section class='mt-5 mb-5' in:slide>
            <div class='row justify-content-center'>
                <div class='col-sm-12 col-md-8 col-lg-6'>
                    <h1 class="text-center">
                        Workplace First Aid<br/>Certificate Authentication
                    </h1>
                    <div class="table-responsive">
                        <table class="table table-hover table-striped">
                            <tbody>
                                <tr>
                                    <th class="col-sm-3">
                                        Who?
                                    </th>
                                    <td class="col-sm-9">
                                        { cert.person }
                                    </td>
                                </tr>
                                <tr>
                                    <th class="col-sm-3">
                                        What?
                                    </th>
                                    <td class="col-sm-9">
                                        { cert.type }
                                    </td>
                                </tr>
                                <tr>
                                    <th class="col-sm-3">
                                        Expires?
                                    </th>
                                    <td class="col-sm-9">
                                        { cert.expiry }
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>            
        </section>

    {:else}

        <div class='alert alert-info clearfix mb-3'>
            <h4 class='float-start me-3'>
                <span class='fas fa-info-circle'></span>
            </h4>
            We are unable to authenticate your Certificate at this time.
        </div>

    {/if}

{/if}